import { useState, useRef } from "react";

// ─── Numerology ───────────────────────────────────────────────────────────────
function reduceToSingle(n) {
  if ([11,22,33].includes(n)) return n;
  if (n < 10) return n;
  return reduceToSingle(String(n).split("").reduce((a,b)=>a+parseInt(b),0));
}
function getLifePath(m,d,y) {
  return reduceToSingle([...String(m),...String(d),...String(y)].reduce((a,b)=>a+parseInt(b),0));
}
function getSoulNumber(name) {
  const v={a:1,e:5,i:9,o:6,u:3};
  return reduceToSingle(name.toLowerCase().split("").reduce((a,c)=>a+(v[c]||0),0))||1;
}
function getDestinyNumber(name) {
  const m={a:1,b:2,c:3,d:4,e:5,f:8,g:3,h:5,i:1,j:1,k:2,l:3,m:4,n:5,o:7,p:8,q:1,r:2,s:3,t:4,u:6,v:6,w:6,x:5,y:1,z:7};
  return reduceToSingle(name.toLowerCase().replace(/[^a-z]/g,"").split("").reduce((a,c)=>a+(m[c]||0),0))||1;
}
const LP_TITLES={1:"The Leader",2:"The Peacemaker",3:"The Creator",4:"The Builder",5:"The Adventurer",6:"The Nurturer",7:"The Seeker",8:"The Powerhouse",9:"The Sage",11:"The Illuminator",22:"The Master Builder",33:"The Master Teacher"};
const MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];
const MONTHS_SHORT=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const READING_TABS=[
  {id:"career",    label:"Career",         icon:"⚡",color:"#e8c066"},
  {id:"love",      label:"Love & Marriage",icon:"♀", color:"#d4889a"},
  {id:"wellbeing", label:"Wellbeing",      icon:"☽", color:"#8aaed4"},
  {id:"health",    label:"Health",         icon:"⊕", color:"#8dc8a4"},
  {id:"future",    label:"Future Outlook", icon:"✦", color:"#a888c8"},
  {id:"issues",    label:"Major Issues",   icon:"♄", color:"#c88878"},
];
const ZODIAC_SIGNS=["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
const SIGN_GLYPHS=["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓"];
const PLANET_SYM={Sun:"☉",Moon:"☽",Mercury:"☿",Venus:"♀",Mars:"♂",Jupiter:"♃",Saturn:"♄",Uranus:"♅",Neptune:"♆",Pluto:"♇"};
const ELEM_COL={Aries:"#d4624a",Taurus:"#7ab878",Gemini:"#5aa8e8",Cancer:"#7888c0",Leo:"#c8a86a",Virgo:"#7ab878",Libra:"#5aa8e8",Scorpio:"#b888d8",Sagittarius:"#d4624a",Capricorn:"#7ab878",Aquarius:"#5aa8e8",Pisces:"#7888c0"};

// ─── Luxury form fields ───────────────────────────────────────────────────────
function FormField({label, children}) {
  return (
    <div style={{marginBottom:24}}>
      <label style={{display:"block",fontFamily:"'Cormorant Garamond',serif",fontSize:11,color:"#b09040",letterSpacing:3,textTransform:"uppercase",marginBottom:10}}>{label}</label>
      {children}
    </div>
  );
}

function LuxurySelect({value, onChange, children, style={}}) {
  return (
    <div style={{position:"relative",...style}}>
      <select value={value} onChange={onChange} style={{
        width:"100%",background:"transparent",
        border:"none",borderBottom:"1px solid rgba(232,192,102,0.4)",
        padding:"10px 28px 10px 2px",color:value?"#e8dcc8":"#c8a840",
        fontFamily:"'Cormorant Garamond',serif",fontSize:16,
        outline:"none",cursor:"pointer",appearance:"none",
        transition:"border-color .2s"
      }}>
        {children}
      </select>
      <span style={{position:"absolute",right:6,top:"50%",transform:"translateY(-50%)",color:"#b09040",fontSize:10,pointerEvents:"none"}}>▾</span>
    </div>
  );
}

function LuxuryInput({value, onChange, placeholder}) {
  return (
    <input value={value} onChange={onChange} placeholder={placeholder} style={{
      width:"100%",background:"transparent",
      border:"none",borderBottom:"1px solid rgba(232,192,102,0.4)",
      padding:"10px 2px",color:"#e8dcc8",
      fontFamily:"'Cormorant Garamond',serif",fontSize:17,
      outline:"none",transition:"border-color .2s"
    }}
    onFocus={e=>e.target.style.borderBottomColor="rgba(200,169,110,0.6)"}
    onBlur={e=>e.target.style.borderBottomColor="rgba(232,192,102,0.4)"}
    />
  );
}

function BirthForm({data, onChange, prefix=""}) {
  const s=(k,v)=>onChange({...data,[k]:v});
  return (
    <>
      <FormField label="Full Name">
        <LuxuryInput value={data.name} onChange={e=>s("name",e.target.value)} placeholder="As on birth certificate"/>
      </FormField>
      <FormField label="Date of Birth">
        <div style={{display:"grid",gridTemplateColumns:"1.6fr 1fr 1.4fr",gap:16}}>
          <LuxurySelect value={data.month} onChange={e=>s("month",e.target.value)}>
            <option value="">Month</option>
            {MONTHS.map((m,i)=><option key={i} value={i+1}>{m}</option>)}
          </LuxurySelect>
          <LuxurySelect value={data.day} onChange={e=>s("day",e.target.value)}>
            <option value="">Day</option>
            {Array.from({length:31},(_,i)=><option key={i} value={i+1}>{i+1}</option>)}
          </LuxurySelect>
          <LuxurySelect value={data.year} onChange={e=>s("year",e.target.value)}>
            <option value="">Year</option>
            {Array.from({length:100},(_,i)=>{const y=2006-i;return <option key={i} value={y}>{y}</option>})}
          </LuxurySelect>
        </div>
      </FormField>
      <FormField label="Time of Birth">
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <LuxurySelect value={data.hour} onChange={e=>s("hour",e.target.value)}>
            <option value="">Hour</option>
            {Array.from({length:24},(_,i)=><option key={i} value={i}>{String(i).padStart(2,"0")}:00</option>)}
          </LuxurySelect>
          <LuxurySelect value={data.minute} onChange={e=>s("minute",e.target.value)}>
            <option value="">Minute</option>
            {Array.from({length:60},(_,i)=><option key={i} value={i}>{String(i).padStart(2,"0")}</option>)}
          </LuxurySelect>
        </div>
      </FormField>
      <FormField label="City of Birth">
        <LuxuryInput value={data.city} onChange={e=>s("city",e.target.value)} placeholder="e.g. Mumbai, London, New York"/>
      </FormField>
    </>
  );
}

const Divider = () => <div style={{height:1,background:"linear-gradient(90deg,transparent,rgba(232,192,102,0.2),transparent)",margin:"28px 0"}}/>;

// ─── Chart Wheel ──────────────────────────────────────────────────────────────
const WHEEL_SIGN_COLORS = ["#e8624a","#7ab878","#5aa8e8","#7888c0","#e8b86d","#7ab878","#5aa8e8","#b888d8","#e8624a","#7ab878","#5aa8e8","#7888c0"];
const WHEEL_SIGNS = ["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓"];
const WHEEL_PLANET_SYM = {Sun:"☉",Moon:"☽",Mercury:"☿",Venus:"♀",Mars:"♂",Jupiter:"♃",Saturn:"♄",Uranus:"♅",Neptune:"♆",Pluto:"♇",Ascendant:"Asc",Medium_Coeli:"MC",Chiron:"⚷"};

function ChartWheel({planets, size}) {
  const S = size || 460;
  const cx = S/2, cy = S/2;
  const R1 = S*0.46, R2 = S*0.38, R3 = S*0.30, R4 = S*0.20;
  const toRad = (d) => (d-90)*Math.PI/180;
  const px = (r,d) => cx + r*Math.cos(toRad(d));
  const py = (r,d) => cy + r*Math.sin(toRad(d));
  const asc = planets.find(p=>p.name==="Ascendant");
  const ascDeg = asc ? (parseFloat(asc.abs_pos)||0) : 0;
  const rot = (d) => ((parseFloat(d)||0) - ascDeg + 360) % 360;
  const validPlanets = planets.filter(p=>p.abs_pos!==undefined && WHEEL_PLANET_SYM[p.name]);

  return (
    <svg viewBox={"0 0 "+S+" "+S} width="100%" style={{maxWidth:S,display:"block",margin:"0 auto"}}>
      <circle cx={cx} cy={cy} r={R1+2} fill="#080d18" stroke="rgba(232,192,102,0.3)" strokeWidth="1"/>
      {WHEEL_SIGNS.map((sym,i) => {
        const a1=rot(i*30), a2=rot((i+1)*30), am=rot(i*30+15);
        const col=WHEEL_SIGN_COLORS[i];
        const lf=0;
        const x1=px(R1,a1),y1=py(R1,a1),x2=px(R2,a1),y2=py(R2,a1);
        const x3=px(R1,a2),y3=py(R1,a2),x4=px(R2,a2),y4=py(R2,a2);
        return (
          <g key={i}>
            <path d={"M "+x1+" "+y1+" A "+R1+" "+R1+" 0 0 1 "+x3+" "+y3+" L "+x4+" "+y4+" A "+R2+" "+R2+" 0 0 0 "+x2+" "+y2+" Z"}
              fill={col} fillOpacity="0.12" stroke={col} strokeOpacity="0.25" strokeWidth="0.5"/>
            <text x={px((R1+R2)/2,am)} y={py((R1+R2)/2,am)} textAnchor="middle" dominantBaseline="middle"
              fontSize={S*0.028} fill={col} fontFamily="serif" opacity="0.9">{sym}</text>
          </g>
        );
      })}
      {Array.from({length:12}).map((_,i) => {
        const a=rot(i*30);
        return <line key={i} x1={px(R2,a)} y1={py(R2,a)} x2={px(R4,a)} y2={py(R4,a)}
          stroke="rgba(232,192,102,0.2)" strokeWidth={i%3===0?1.5:0.5}/>;
      })}
      {Array.from({length:12}).map((_,i) => {
        const a=rot(i*30+15);
        return <text key={i} x={px((R3+R4)/2,a)} y={py((R3+R4)/2,a)} textAnchor="middle" dominantBaseline="middle"
          fontSize={S*0.022} fill="rgba(232,192,102,0.4)" fontFamily="serif">{i+1}</text>;
      })}
      <circle cx={cx} cy={cy} r={R4} fill="#080d18" stroke="rgba(232,192,102,0.25)" strokeWidth="1"/>
      {validPlanets.map((p,i) => {
        const a=rot(p.abs_pos);
        const signIdx=Math.floor(((parseFloat(p.abs_pos)||0)/30))%12;
        const col=WHEEL_SIGN_COLORS[signIdx]||"#e8c066";
        return (
          <g key={i}>
            <circle cx={px(R3,a)} cy={py(R3,a)} r={S*0.022} fill="#0d1428" stroke={col} strokeWidth="0.8"/>
            <text x={px(R3,a)} y={py(R3,a)} textAnchor="middle" dominantBaseline="middle"
              fontSize={S*0.02} fill={col} fontFamily="serif">{WHEEL_PLANET_SYM[p.name]||"●"}</text>
          </g>
        );
      })}
      {[["ASC",0],["IC",90],["DSC",180],["MC",270]].map(([label,deg]) => (
        <text key={label} x={px(R2-6,rot(deg))} y={py(R2-6,rot(deg))} textAnchor="middle" dominantBaseline="middle"
          fontSize={S*0.02} fill="#e8c066" fontFamily="serif" fontWeight="600">{label}</text>
      ))}
      <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle"
        fontSize={S*0.05} fill="rgba(232,192,102,0.4)" fontFamily="serif">⊕</text>
    </svg>
  );
}

const emptyPerson = {name:"",month:"",day:"",year:"",hour:"",minute:"",city:""};

export default function OracleAstro() {
  const [appTab, setAppTab] = useState("reading"); // reading | compatibility | daily
  const [stage, setStage] = useState("form");
  const [person1, setPerson1] = useState({...emptyPerson});
  const [person2, setPerson2] = useState({...emptyPerson});
  const [errorMsg, setErrorMsg] = useState("");
  const [chartData, setChartData] = useState(null);
  const [readings, setReadings] = useState({});
  const [activeTab, setActiveTab] = useState("career");
  const [numerology, setNumerology] = useState(null);
  const [mainView, setMainView] = useState("chart");
  // Compatibility
  const [compatStage, setCompatStage] = useState("form");
  const [compatScore, setCompatScore] = useState(null);
  const [compatReading, setCompatReading] = useState("");
  const [compatLoading, setCompatLoading] = useState(false);
  const [compatExpanded, setCompatExpanded] = useState(false);
  // Daily
  const [dailySign, setDailySign] = useState("");
  const [dailyReading, setDailyReading] = useState("");
  const [dailyLoading, setDailyLoading] = useState(false);

  const chartWheelRef = useRef(null);

  async function downloadPDF() {
    try {
      await new Promise((resolve, reject) => {
        if (window.jspdf) { resolve(); return; }
        const s = document.createElement("script");
        s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
        s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });

      const {jsPDF} = window.jspdf;
      const pdf = new jsPDF({orientation:"portrait", unit:"mm", format:"a4"});
      const W = 210, margin = 18;
      let y = 20;

      // Helper functions
      const addLine = (thick=false) => {
        pdf.setDrawColor(200,169,70); pdf.setLineWidth(thick?0.5:0.2);
        pdf.line(margin, y, W-margin, y); y += 6;
      };
      const addText = (text, size, color, bold=false, center=false) => {
        pdf.setFontSize(size);
        pdf.setTextColor(...color);
        pdf.setFont("helvetica", bold?"bold":"normal");
        const x = center ? W/2 : margin;
        const align = center ? "center" : "left";
        const lines = pdf.splitTextToSize(text, W - margin*2);
        lines.forEach(line => {
          if (y > 270) { pdf.addPage(); y = 20; }
          pdf.text(line, x, y, {align});
          y += size * 0.5;
        });
        y += 2;
      };

      // Cover
      pdf.setFillColor(8,13,24);
      pdf.rect(0,0,W,297,"F");
      pdf.setFillColor(20,30,60);
      pdf.rect(0,80,W,137,"F");
      addText("ORACLE ASTRO", 28, [232,192,102], true, true); y += 4;
      addText("Complete Life Reading", 14, [160,140,80], false, true); y += 16;
      addLine(true); y += 8;
      addText(person1.name, 22, [232,192,102], true, true); y += 4;
      addText(`${person1.day} ${MONTHS_SHORT[parseInt(person1.month)-1]} ${person1.year} · ${person1.city}`, 11, [120,100,60], false, true);
      y += 8; addLine();
      const numLine = numerology ? `Life Path ${numerology.lp} · Soul ${numerology.soul} · Destiny ${numerology.destiny}` : "";
      if (numLine) addText(numLine, 10, [150,130,70], false, true);
      y += 20;
      addText("oracleastro.com", 9, [80,70,40], false, true);

      // Readings
      const tabDefs = [
        {id:"career", label:"Career & Professional Life", icon:"⚡"},
        {id:"love", label:"Love & Marriage", icon:"♀"},
        {id:"wellbeing", label:"Emotional Wellbeing", icon:"☽"},
        {id:"health", label:"Health & Vitality", icon:"⊕"},
        {id:"future", label:"Future Outlook & Destiny", icon:"✦"},
        {id:"issues", label:"Major Life Issues & Karmic Lessons", icon:"♄"},
      ];

      tabDefs.forEach(tab => {
        if (!readings[tab.id]) return;
        pdf.addPage();
        pdf.setFillColor(8,13,24); pdf.rect(0,0,W,297,"F");
        y = 20;
        addText(tab.label.toUpperCase(), 16, [232,192,102], true, false);
        addLine(true);
        y += 2;
        // Body
        const body = readings[tab.id].body.replace(/\*\*/g,"");
        addText(body, 10, [200,185,155]);
        // Timeline
        if (readings[tab.id].timeline) {
          y += 4;
          addText("LIFE TIMELINE", 11, [180,150,60], true);
          addLine();
          readings[tab.id].timeline.split("\n").filter(l=>l.trim()).forEach(line => {
            const clean = line.replace(/^\*+\s*/,"").replace(/\*\*/g,"").trim();
            if (!clean) return;
            const ci = clean.indexOf(":");
            if (ci > 0 && ci < 40) {
              addText(clean.slice(0,ci).toUpperCase(), 9, [232,192,102], true);
              y -= 2;
              addText(clean.slice(ci+1).trim(), 9, [160,145,115]);
            } else {
              addText(clean, 9, [160,145,115]);
            }
          });
        }
      });

      // Numerology page
      if (numerology) {
        pdf.addPage();
        pdf.setFillColor(8,13,24); pdf.rect(0,0,W,297,"F");
        y = 20;
        addText("NUMEROLOGICAL PROFILE", 16, [232,192,102], true);
        addLine(true); y += 4;
        [
          {label:"Life Path Number", num:numerology.lp, desc:LP_TITLES[numerology.lp]||""},
          {label:"Soul Number", num:numerology.soul, desc:"Inner Desire"},
          {label:"Destiny Number", num:numerology.destiny, desc:"Outer Expression"}
        ].forEach(({label,num,desc}) => {
          addText(label, 11, [180,150,60], true);
          addText(String(num), 24, [232,192,102], true);
          addText(desc, 10, [150,130,80]);
          y += 4;
        });
      }

      // Planet positions page
      if (planetList.length > 0) {
        pdf.addPage();
        pdf.setFillColor(8,13,24); pdf.rect(0,0,W,297,"F");
        y = 20;
        addText("PLANETARY POSITIONS", 16, [232,192,102], true);
        addLine(true); y += 4;
        planetList.filter(p=>p.sign_name).forEach(p => {
          if (y > 270) { pdf.addPage(); pdf.setFillColor(8,13,24); pdf.rect(0,0,W,297,"F"); y = 20; }
          pdf.setFontSize(10); pdf.setTextColor(180,150,70); pdf.setFont("helvetica","bold");
          pdf.text(p.name, margin, y);
          pdf.setTextColor(200,185,155); pdf.setFont("helvetica","normal");
          pdf.text(p.sign_name+(p.house?" · H"+p.house:""), margin+50, y);
          y += 7;
        });
      }

      // Footer on all pages
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i=1; i<=totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(8); pdf.setTextColor(60,50,30);
        pdf.text("oracleastro.com", W/2, 290, {align:"center"});
        pdf.text(`${i} / ${totalPages}`, W-margin, 290, {align:"right"});
      }

      pdf.save(person1.name.replace(/ /g,"_")+"-OracleAstro-Reading.pdf");
    } catch(e) {
      console.error(e);
      alert("PDF download failed: "+e.message);
    }
  }

  // ── Fetch chart + generate readings ─────────────────────────────────────────
  async function fetchChart() {
    const {name,month,day,year,hour,minute,city}=person1;
    if (!name||!month||!day||!year||!city){setErrorMsg("Please fill in all fields.");return;}
    setErrorMsg(""); setStage("loading"); setReadings({});
    try {
      const body={name,year:parseInt(year),month:parseInt(month),day:parseInt(day),hour:parseInt(hour)||0,minute:parseInt(minute)||0,city};
      const res=await fetch("https://chart-woad.vercel.app/api/chart",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
      if(!res.ok) throw new Error(`Chart error: ${await res.text()}`);
      const data=await res.json();
      const lp=getLifePath(parseInt(month),parseInt(day),parseInt(year));
      const soul=getSoulNumber(name);
      const destiny=getDestinyNumber(name);
      setNumerology({lp,soul,destiny});
      setChartData(data);
      setStage("result");
      setMainView("chart");
      setActiveTab("career");
      generateAllReadings(data,name,{lp,soul,destiny},parseInt(year),parseInt(month),parseInt(day));
    } catch(e){setErrorMsg(e.message||"Something went wrong.");setStage("form");}
  }

  async function generateAllReadings(data,name,num,birthYear,birthMonth,birthDay) {
    const planets=(data.planets||[]).filter(p=>p&&p.name);
    const get=(n)=>planets.find(p=>p.name===n);
    const sign=(p)=>p?.sign_name||p?.sign||"?";
    const currentYear=new Date().getFullYear();
    const age=currentYear-birthYear;
    // Accurate Saturn return ages
    const saturnReturn1=birthYear+29;
    const saturnReturn2=birthYear+58;
    const jupiterCycle1=birthYear+12;
    const jupiterCycle2=birthYear+24;
    const jupiterCycle3=birthYear+36;
    const planetSummary=planets.slice(0,12).map(p=>`${p.name} in ${sign(p)} H${p.house||"?"}`).join(", ");

    const prompt=`You are a master astrologer giving a lifetime reading for ${name}, born ${birthDay} ${MONTHS_SHORT[birthMonth-1]} ${birthYear} in ${person1.city}. Age ${age}.

CHART: ${planetSummary}
Sun: ${sign(get("Sun"))} | Moon: ${sign(get("Moon"))} | Rising: ${sign(get("Ascendant")||get("First_House")||get("Asc"))}
Venus: ${sign(get("Venus"))} | Mars: ${sign(get("Mars"))} | Saturn: ${sign(get("Saturn"))} | Jupiter: ${sign(get("Jupiter"))}
MC: ${sign(get("Midheaven")||get("Medium_Coeli"))}
Life Path: ${num.lp} (${LP_TITLES[num.lp]||""}) | Soul: ${num.soul} | Destiny: ${num.destiny}
Saturn Returns: age 29-30 (${saturnReturn1}-${saturnReturn1+1}), age 58-60 (${saturnReturn2}-${saturnReturn2+2})
Now: age ${age}, year ${currentYear}

Write 6 personal readings for ${name}. Each: 2-3 paragraphs + 5 timeline entries covering now through age 60s. Use actual ages/years. Speak as "you". Be poetic and specific.

###CAREER###
[2-3 paragraphs]
TIMELINE:
Age ${age} (${currentYear}): [now]
Age ${age+5} (${currentYear+5}): [near future]
Age 30s: [building phase]
Age 40s-50s: [peak]
Age 60s: [legacy]

###LOVE###
[2-3 paragraphs]
TIMELINE:
Age ${age} (${currentYear}): [now]
Age ${age+5} (${currentYear+5}): [near future]
Age 30s: [deepening]
Age 40s-50s: [maturity]
Age 60s: [fulfillment]

###WELLBEING###
[2-3 paragraphs]
TIMELINE:
Age ${age} (${currentYear}): [now]
Age ${age+5} (${currentYear+5}): [shift]
Age 30s: [integration]
Age 40s-50s: [wisdom]
Age 60s: [peace]

###HEALTH###
[2-3 paragraphs]
TIMELINE:
Age ${age} (${currentYear}): [now]
Age ${age+5} (${currentYear+5}): [focus]
Age 30s: [vitality]
Age 40s-50s: [maintenance]
Age 60s: [longevity]

###FUTURE###
[2-3 paragraphs]
TIMELINE:
Age ${age} (${currentYear}): [now]
Age ${age+5} (${currentYear+5}): [next chapter]
Age 30s: [milestone]
Age 40s-50s: [culmination]
Age 60s: [destiny]

###ISSUES###
[2-3 paragraphs]
TIMELINE:
Age ${age} (${currentYear}): [current test]
Age ${age+5} (${currentYear+5}): [shift]
Age 30s: [reckoning]
Age 40s-50s: [integration]
Age 60s: [resolution]`

    try {
      const res=await fetch("https://chart-woad.vercel.app/api/gemini",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({prompt})});
      const d=await res.json();
      const text=d.candidates?.[0]?.content?.parts?.[0]?.text||"";
      parseReadings(text);
    } catch(e){console.error(e);}
  }

  function parseReadings(text) {
    const markers={career:"###CAREER###",love:"###LOVE###",wellbeing:"###WELLBEING###",health:"###HEALTH###",future:"###FUTURE###",issues:"###ISSUES###"};
    const keys=Object.keys(markers);
    const parsed={};
    keys.forEach((key,i)=>{
      const start=text.indexOf(markers[key]);
      if(start===-1) return;
      const end=i<keys.length-1?text.indexOf(markers[keys[i+1]]):text.length;
      const raw=text.slice(start+markers[key].length,end===-1?text.length:end).trim();
      const tIdx=raw.indexOf("TIMELINE:");
      parsed[key]=tIdx>-1?{body:raw.slice(0,tIdx).trim(),timeline:raw.slice(tIdx+9).trim()}:{body:raw,timeline:""};
    });
    setReadings(parsed);
  }

  // ── Compatibility ────────────────────────────────────────────────────────────
  async function fetchCompatibility() {
    const p1=person1, p2=person2;
    if(!p1.name||!p1.month||!p1.day||!p1.year||!p2.name||!p2.month||!p2.day||!p2.year){
      setErrorMsg("Please fill in both people's details.");return;
    }
    setErrorMsg(""); setCompatLoading(true); setCompatScore(null); setCompatReading(""); setCompatExpanded(false);
    try {
      const lp1=getLifePath(parseInt(p1.month),parseInt(p1.day),parseInt(p1.year));
      const lp2=getLifePath(parseInt(p2.month),parseInt(p2.day),parseInt(p2.year));
      const prompt=`You are a master astrologer. Analyze compatibility between:
Person 1: ${p1.name}, born ${p1.day} ${MONTHS_SHORT[parseInt(p1.month)-1]} ${p1.year} in ${p1.city||"unknown"}, Life Path ${lp1}
Person 2: ${p2.name}, born ${p2.day} ${MONTHS_SHORT[parseInt(p2.month)-1]} ${p2.year} in ${p2.city||"unknown"}, Life Path ${lp2}

Sun signs: ${getSunSign(parseInt(p1.month),parseInt(p1.day))} and ${getSunSign(parseInt(p2.month),parseInt(p2.day))}

Respond in this EXACT format:
SCORE: [number 1-100]
VERDICT: [one line summary, max 12 words]
STRENGTHS: [2-3 sentences about what works beautifully between them]
CHALLENGES: [2-3 sentences about the friction points and growth edges]
DEEP_READING: [4-5 rich paragraphs — soul contract, karmic connection, sexual/romantic chemistry, long-term compatibility arc, what they teach each other. Be poetic and specific.]
TIMELINE:
Early years together: [What the first 1-3 years look like]
Year 3-7: [Deepening or crisis point]
Year 7-12: [The real test]
Long term (15+ years): [What endures]`;

      const res=await fetch("https://chart-woad.vercel.app/api/gemini",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({prompt})});
      const d=await res.json();
      const text=d.candidates?.[0]?.content?.parts?.[0]?.text||"";
      parseCompatibility(text);
    } catch(e){setErrorMsg("Reading failed. Please try again.");}
    setCompatLoading(false);
  }

  function parseCompatibility(text) {
    const get=(key,nextKey)=>{
      const start=text.indexOf(key+":"); if(start===-1) return "";
      const end=nextKey?text.indexOf(nextKey+":"):text.length;
      return text.slice(start+key.length+1,end===-1?text.length:end).trim();
    };
    const scoreStr=get("SCORE","VERDICT");
    const score=parseInt(scoreStr)||75;
    setCompatScore({
      score,
      verdict:get("VERDICT","STRENGTHS"),
      strengths:get("STRENGTHS","CHALLENGES"),
      challenges:get("CHALLENGES","DEEP_READING"),
      deepReading:get("DEEP_READING","TIMELINE"),
      timeline:get("TIMELINE","XXXXXX"),
    });
    setCompatStage("result");
  }

  function getSunSign(month,day) {
    const dates=[[1,20,"Aquarius"],[2,19,"Pisces"],[3,20,"Aries"],[4,20,"Taurus"],[5,21,"Gemini"],[6,21,"Cancer"],[7,22,"Leo"],[8,23,"Virgo"],[9,23,"Libra"],[10,23,"Scorpio"],[11,22,"Sagittarius"],[12,22,"Capricorn"],[12,31,"Capricorn"]];
    for(const [m,d,sign] of dates){if(month<m||(month===m&&day<=d)) return sign;}
    return "Capricorn";
  }

  async function fetchDailyReading() {
    if(!dailySign) return;
    setDailyLoading(true); setDailyReading("");
    try {
      const today=new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"});
      const prompt=`Daily horoscope for ${dailySign} on ${today}. 3 sentences: inner world, external opportunity, poetic closing nudge. Evocative, second person, no sign name.`;
      const res=await fetch("https://chart-woad.vercel.app/api/gemini",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({prompt})});
      const d=await res.json();
      setDailyReading(d.candidates?.[0]?.content?.parts?.[0]?.text||"The stars are quiet today.");
    } catch{setDailyReading("The cosmos is momentarily silent.");}
    setDailyLoading(false);
  }

  const planetList = chartData?.planets
    ? chartData.planets.filter(p => p && p.name && p.sign_name)
    : [];

  
  return (
    <div style={{minHeight:"100vh",background:"#080d18",color:"#f5f0e8",fontFamily:"'Cormorant Garamond',serif",position:"relative",overflowX:"hidden"}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500&family=Cormorant+SC:wght@300;400;500;600&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        @keyframes fadeUp{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
        @keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
        @keyframes glow{0%,100%{opacity:.6}50%{opacity:1}}
        .fade{animation:fadeUp .6s ease both;}
        .section{background:rgba(255,255,255,0.04);border:1px solid rgba(232,192,102,0.3);border-radius:4px;padding:32px;}
        .rtab{background:transparent;border:none;border-left:2px solid rgba(232,192,102,0.2);padding:14px 18px;cursor:pointer;text-align:left;width:100%;transition:all .2s;margin-bottom:2px;}
        .rtab:hover{border-left-color:rgba(232,192,102,0.5);background:rgba(255,255,255,0.03);}
        .rtab.active{border-left-color:#e8c066;background:rgba(255,255,255,0.04);}
        .tline{position:relative;padding:14px 0 14px 28px;border-left:1px solid rgba(232,192,102,0.3);}
        .tline::before{content:'';position:absolute;left:-4px;top:20px;width:7px;height:7px;border-radius:50%;background:#e8c066;box-shadow:0 0 12px rgba(212,168,71,0.6);}
        .sign-btn{background:rgba(255,255,255,0.03);border:1px solid rgba(232,192,102,0.2);border-radius:4px;padding:12px 6px;cursor:pointer;text-align:center;transition:all .15s;color:#b09040;width:100%;}
        .sign-btn:hover,.sign-btn.sel{border-color:rgba(232,192,102,0.6);color:#e8c066;background:rgba(232,192,102,0.08);}
        .app-tab{background:transparent;border:none;color:#8890b0;font-family:'Cormorant SC',serif;font-size:17px;letter-spacing:3px;padding:16px 28px;cursor:pointer;transition:all .2s;border-bottom:2px solid transparent;white-space:nowrap;}
        .app-tab.active{color:#e8c066;border-bottom-color:#e8c066;}
        .btn{background:transparent;border:1px solid rgba(232,192,102,0.5);color:#e8c066;font-family:'Cormorant SC',serif;font-size:12px;letter-spacing:3px;padding:16px;width:100%;cursor:pointer;transition:all .25s;}
        .btn:hover{background:rgba(232,192,102,0.2);border-color:rgba(200,169,110,0.55);}
        .btn:disabled{opacity:.25;cursor:not-allowed;}
        .score-ring{position:relative;width:140px;height:140px;margin:0 auto;}
        @media(max-width:768px){
          .desktop-sidebar{display:none!important;}
          .reading-grid{grid-template-columns:1fr!important;}
          .compat-grid{grid-template-columns:1fr!important;}
          .num-grid{grid-template-columns:1fr!important;}
          .planet-grid{grid-template-columns:1fr!important;}
          .app-tab{padding:10px 12px!important;font-size:10px!important;letter-spacing:1px!important;}
          .section{padding:18px!important;}
          .score-grid{grid-template-columns:1fr!important;}
          h1{letter-spacing:6px!important;}
          .mobile-tab-sel{display:block!important;margin-bottom:8px;}
          .sign-grid{grid-template-columns:repeat(4,1fr)!important;}
        }
      `}</style>

      {/* Background texture */}
      <div style={{position:"fixed",inset:0,backgroundImage:"radial-gradient(ellipse at 20% 20%, rgba(255,255,255,0.04) 0%, transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(20,40,100,0.2) 0%, transparent 60%)",pointerEvents:"none",zIndex:0}}/>

      <div style={{position:"relative",zIndex:1,maxWidth:1000,margin:"0 auto",padding:"48px 24px 100px"}}>

        {/* ── HEADER ── */}
        <div style={{textAlign:"center",marginBottom:48,animation:"fadeUp .8s ease"}}>
          <div style={{display:"flex",justifyContent:"center",flexWrap:"nowrap",overflowX:"auto",gap:4,marginBottom:16,padding:"0 8px",width:"100%",scrollbarWidth:"none",WebkitOverflowScrolling:"touch"}}>
            {["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓"].map((g,i)=>(
              <span key={i} style={{fontSize:18,flexShrink:0}}>{g}</span>
            ))}
          </div>
          <h1 style={{fontFamily:"'Cormorant SC',serif",fontSize:"clamp(32px,6vw,60px)",fontWeight:300,letterSpacing:12,color:"#e8c066",textShadow:"0 0 80px rgba(232,192,102,0.3)",lineHeight:1}}>
            ORACLE ASTRO
          </h1>
          <div style={{width:60,height:1,background:"linear-gradient(90deg,transparent,rgba(212,168,71,0.6),transparent)",margin:"20px auto"}}/>
          <p style={{color:"#c0a040",fontSize:13,letterSpacing:4,fontFamily:"'Cormorant SC',serif",fontWeight:300}}>
            ASTROLOGY · BIRTH CHARTS · READINGS
          </p>
        </div>

        {/* ── APP TABS ── */}
        <div style={{display:"flex",justifyContent:"center",borderBottom:"1px solid rgba(232,192,102,0.25)",marginBottom:40}}>
          {[["reading","⊕  Life Reading"],["compatibility","♀  Compatibility"],["daily","☽  Daily Oracle"]].map(([k,l])=>(
            <button key={k} className={`app-tab ${appTab===k?"active":""}`} onClick={()=>{setAppTab(k);if(k==="reading"&&stage==="result"){}}}>{l}</button>
          ))}
        </div>

        {/* ════════════════════════════════════════════════════════════════ */}
        {/* ── LIFE READING ── */}
        {/* ════════════════════════════════════════════════════════════════ */}
        {appTab==="reading" && (
          <>
            {stage==="form" && (
              <div className="fade section" style={{maxWidth:560,margin:"0 auto"}}>
                <div style={{textAlign:"center",marginBottom:32}}>
                  <h2 style={{fontFamily:"'Cormorant SC',serif",fontSize:18,fontWeight:300,letterSpacing:4,color:"#e8c066"}}>Your Complete Life Reading</h2>
                  <p style={{color:"#c8a840",fontSize:14,marginTop:8,letterSpacing:1}}>Career · Love · Health · Destiny · Lifetime Timeline</p>
                </div>
                <BirthForm data={person1} onChange={setPerson1}/>
                {errorMsg&&<p style={{color:"#c87870",fontSize:13,marginBottom:16,letterSpacing:1}}>{errorMsg}</p>}
                <button className="btn" onClick={fetchChart}>Cast My Life Reading</button>
              </div>
            )}

            {stage==="loading" && (
              <div style={{textAlign:"center",padding:"80px 0"}}>
                <div style={{position:"relative",width:120,height:120,margin:"0 auto 32px"}}>
                  <svg viewBox="0 0 120 120" style={{position:"absolute",inset:0,animation:"spin 12s linear infinite"}}>
                    <circle cx="60" cy="60" r="54" fill="none" stroke="rgba(232,192,102,0.2)" strokeWidth="1"/>
                    <circle cx="60" cy="8" r="2.5" fill="rgba(232,192,102,0.5)"/>
                    <circle cx="88" cy="18" r="2.5" fill="rgba(232,192,102,0.4)"/>
                    <circle cx="106" cy="44" r="2.5" fill="rgba(232,192,102,0.5)"/>
                    <circle cx="106" cy="72" r="2.5" fill="rgba(232,192,102,0.4)"/>
                    <circle cx="88" cy="98" r="2.5" fill="rgba(232,192,102,0.5)"/>
                    <circle cx="60" cy="110" r="2.5" fill="rgba(232,192,102,0.4)"/>
                    <circle cx="32" cy="98" r="2.5" fill="rgba(232,192,102,0.5)"/>
                    <circle cx="14" cy="72" r="2.5" fill="rgba(232,192,102,0.4)"/>
                    <circle cx="14" cy="44" r="2.5" fill="rgba(232,192,102,0.5)"/>
                    <circle cx="32" cy="18" r="2.5" fill="rgba(232,192,102,0.4)"/>
                    <circle cx="56" cy="8" r="2.5" fill="rgba(232,192,102,0.5)"/>
                    <circle cx="84" cy="14" r="2.5" fill="rgba(232,192,102,0.4)"/>
                  </svg>
                  <svg viewBox="0 0 120 120" style={{position:"absolute",inset:0,animation:"spin 4s linear infinite reverse"}}>
                    <circle cx="60" cy="60" r="36" fill="none" stroke="rgba(232,192,102,0.25)" strokeWidth="1" strokeDasharray="4 8"/>
                  </svg>
                  <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,color:"#e8c066",opacity:.7,animation:"glow 2s ease-in-out infinite"}}>⊕</div>
                </div>
                <p style={{fontFamily:"'Cormorant SC',serif",fontSize:11,letterSpacing:5,color:"#b09040",marginBottom:10}}>CONSULTING THE CELESTIAL RECORD</p>
                <p style={{color:"#c8a840",fontSize:14,fontStyle:"italic",letterSpacing:1}}>Building your complete lifetime reading...</p>
              </div>
            )}

            {stage==="result" && (
              <div className="fade">
                {/* Person header */}
                <div style={{textAlign:"center",marginBottom:32}}>
                  <p style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:4,marginBottom:8}}>COMPLETE LIFE READING FOR</p>
                  <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:"clamp(24px,4vw,36px)",fontWeight:300,color:"#e8c066",letterSpacing:3}}>{person1.name}</h2>
                  <p style={{color:"#a08830",fontSize:13,marginTop:6,letterSpacing:1}}>
                    {person1.day} {MONTHS_SHORT[parseInt(person1.month)-1]} {person1.year} · {person1.city}
                  </p>
                </div>

                {/* Sub-nav */}
                <div style={{display:"flex",alignItems:"center",borderBottom:"1px solid rgba(232,192,102,0.25)",marginBottom:28,overflowX:"auto"}}>
                  {[["chart","Reading"],["wheel","Chart Wheel"],["numerology","Numbers"],["daily","Daily"]].map(([k,l])=>(
                    <button key={k} style={{background:"none",border:"none",borderBottom:`1px solid ${mainView===k?"#e8c066":"transparent"}`,color:mainView===k?"#e8c066":"#a08830",fontFamily:"'Cormorant SC',serif",fontSize:13,letterSpacing:2,padding:"12px 22px",cursor:"pointer",transition:"all .2s",whiteSpace:"nowrap"}}
                      onClick={()=>setMainView(k)}>{l}</button>
                  ))}
                  <button onClick={()=>{setStage("form");setChartData(null);setReadings({});}} style={{marginLeft:"auto",background:"none",border:"none",color:"#806820",fontFamily:"'Cormorant SC',serif",fontSize:10,letterSpacing:2,cursor:"pointer",padding:"10px 16px"}}>
                    ↺ NEW
                  </button>
                </div>

                {/* Chart reading */}
                {mainView==="chart" && (
                  <div className="reading-grid" style={{display:"grid",gridTemplateColumns:"200px 1fr",gap:20,alignItems:"start"}}>
                    {/* Sidebar */}
                    <div className="desktop-sidebar">
                      {READING_TABS.map(tab=>(
                        <button key={tab.id} className={`rtab ${activeTab===tab.id?"active":""}`} onClick={()=>setActiveTab(tab.id)}>
                          <div style={{display:"flex",alignItems:"center",gap:10}}>
                            <span style={{color:activeTab===tab.id?tab.color:"#806820",fontSize:17,opacity:activeTab===tab.id?1:0.4}}>{tab.icon}</span>
                            <div>
                              <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,letterSpacing:2,color:activeTab===tab.id?tab.color:"#a08830"}}>{tab.label}</div>
                              <div style={{fontSize:10,color:readings[tab.id]?"#3a5a3a":"#1a1a2a",marginTop:2,fontStyle:"italic"}}>{readings[tab.id]?"ready":"···"}</div>
                            </div>
                          </div>
                        </button>
                      ))}
                      <Divider/>
                      {/* Planet list */}
                      {planetList.slice(0,10).map((p,i)=>(
                        <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 18px",borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                          <span style={{fontSize:12,color:"#a08830",fontFamily:"'Cormorant SC',serif",letterSpacing:1}}>{p.name}</span>
                          <span style={{fontSize:12,color:ELEM_COL[p.sign_name||p.sign]||"#e8c066"}}>{p.sign_name||p.sign||""}</span>
                        </div>
                      ))}
                    </div>

                    {/* Reading */}
                    {/* Mobile tab selector */}
                    <div style={{display:"none"}} className="mobile-tab-sel">
                      <select value={activeTab} onChange={e=>setActiveTab(e.target.value)} style={{width:"100%",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(232,192,102,0.35)",padding:"12px 16px",color:"#e8c066",fontFamily:"'Cormorant SC',serif",fontSize:13,letterSpacing:2,outline:"none",marginBottom:12,borderRadius:2}}>
                        {READING_TABS.map(t=><option key={t.id} value={t.id} style={{background:"#080d18"}}>{t.label}</option>)}
                      </select>
                    </div>
                    <div className="section" style={{minHeight:500}}>
                      {!readings[activeTab] ? (
                        <div>
                          {[100,85,72,90,65].map((w,i)=><div key={i} style={{height:13,borderRadius:2,marginBottom:10,width:w+"%",background:"linear-gradient(90deg,rgba(255,255,255,0.04) 0%,rgba(232,192,102,0.18) 50%,rgba(255,255,255,0.04) 100%)",backgroundSize:"200% 100%",animation:"shimmer 1.5s infinite"}}/>)}
                          <div style={{height:20}}/>
                          {[95,80,60].map((w,i)=><div key={i} style={{height:13,borderRadius:2,marginBottom:10,width:w+"%",background:"linear-gradient(90deg,rgba(255,255,255,0.04) 0%,rgba(232,192,102,0.18) 50%,rgba(255,255,255,0.04) 100%)",backgroundSize:"200% 100%",animation:"shimmer 1.5s infinite"}}/>)}
                          <p style={{textAlign:"center",color:"#806820",fontSize:13,marginTop:32,fontStyle:"italic",letterSpacing:1}}>Generating your lifetime reading...</p>
                        </div>
                      ) : (
                        <div className="fade">
                          <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24,paddingBottom:20,borderBottom:"1px solid rgba(232,192,102,0.25)"}}>
                            <span style={{fontSize:32,color:READING_TABS.find(t=>t.id===activeTab)?.color}}>{READING_TABS.find(t=>t.id===activeTab)?.icon}</span>
                            <div>
                              <h3 style={{fontFamily:"'Cormorant SC',serif",fontSize:14,letterSpacing:3,color:READING_TABS.find(t=>t.id===activeTab)?.color}}>{READING_TABS.find(t=>t.id===activeTab)?.label}</h3>
                              <p style={{fontSize:12,color:"#a08830",marginTop:3,letterSpacing:1}}>Lifetime reading for {person1.name}</p>
                            </div>
                          </div>
                          {readings[activeTab].body.split("\n\n").filter(Boolean).map((para,i)=>(
                            <p key={i} style={{lineHeight:2,color:"#c8b87a",fontSize:16,marginBottom:18,fontStyle:"italic",fontWeight:300}}>{para.replace(/\*\*/g,"")}</p>
                          ))}
                          {readings[activeTab].timeline && (
                            <>
                              <div style={{display:"flex",alignItems:"center",gap:16,margin:"28px 0 20px"}}>
                                <div style={{flex:1,height:1,background:"rgba(232,192,102,0.25)"}}/>
                                <span style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3}}>LIFE TIMELINE</span>
                                <div style={{flex:1,height:1,background:"rgba(232,192,102,0.25)"}}/>
                              </div>
                              <div style={{paddingLeft:16}}>
                                {readings[activeTab].timeline.split("\n").filter(l=>l.trim()).map((line,i)=>{
                                  const clean=line.replace(/^\*+\s*/,"").replace(/\*\*/g,"").trim();
                                  if(!clean) return null;
                                  const ci=clean.indexOf(":");
                                  const hasDate=ci>0&&ci<40;
                                  return (
                                    <div key={i} className="tline">
                                      {hasDate?(<>
                                        <div style={{fontFamily:"'Cormorant SC',serif",fontSize:11,color:"#e8c066",letterSpacing:2,marginBottom:4}}>{clean.slice(0,ci).toUpperCase()}</div>
                                        <div style={{fontSize:14,color:"#a08840",lineHeight:1.8,fontStyle:"italic"}}>{clean.slice(ci+1).trim()}</div>
                                      </>):(
                                        <div style={{fontSize:14,color:"#a08840",lineHeight:1.8,fontStyle:"italic"}}>{clean}</div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Chart Wheel */}
                {mainView==="wheel" && (
                  <div className="fade">
                    <div className="section" style={{padding:24,marginBottom:16}} ref={chartWheelRef}>
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",gap:10}}>
                        <div>
                          <h3 style={{fontFamily:"'Cormorant SC',serif",fontSize:13,letterSpacing:3,color:"#e8c066"}}>NATAL CHART WHEEL</h3>
                          <p style={{fontSize:12,color:"#8a7450",marginTop:4,fontFamily:"'Cormorant SC',serif"}}>{person1.name} · {person1.day} {MONTHS_SHORT[parseInt(person1.month)-1]} {person1.year}</p>
                        </div>
                        <button onClick={downloadPDF} style={{background:"rgba(232,192,102,0.08)",border:"1px solid rgba(232,192,102,0.3)",color:"#e8c066",fontFamily:"'Cormorant SC',serif",fontSize:10,letterSpacing:2,padding:"10px 18px",cursor:"pointer",borderRadius:2}}>
                          ↓ Download PDF
                        </button>
                      </div>
                      {planetList.length > 0
                        ? <ChartWheel planets={planetList} size={460}/>
                        : <p style={{textAlign:"center",color:"#5a4a30",fontStyle:"italic",padding:"40px 0"}}>Cast a birth chart to view the wheel</p>
                      }
                    </div>
                    <div className="section" style={{padding:16}}>
                      <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#8a7450",letterSpacing:3,marginBottom:12}}>PLANET POSITIONS</div>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4}}>
                        {planetList.filter(p=>WHEEL_PLANET_SYM[p.name]).map((p,i)=>(
                          <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",borderBottom:"1px solid rgba(232,192,102,0.06)"}}>
                            <span style={{fontSize:14,color:WHEEL_SIGN_COLORS[Math.floor((parseFloat(p.abs_pos)||0)/30)%12]}}>{WHEEL_PLANET_SYM[p.name]||"●"}</span>
                            <span style={{fontSize:11,color:"#8a7450",fontFamily:"'Cormorant SC',serif",width:70}}>{p.name}</span>
                            <span style={{fontSize:12,color:"#c8b070"}}>{p.sign_name}</span>
                            {p.house&&<span style={{fontSize:10,color:"#5a4a30",marginLeft:"auto"}}>H{p.house}</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Numerology */}
                {mainView==="numerology" && numerology && (
                  <div className="fade">
                    <div className="num-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:20}}>
                      {[
                        {label:"Life Path",num:numerology.lp,sub:LP_TITLES[numerology.lp]||""},
                        {label:"Soul Number",num:numerology.soul,sub:"Inner Desire"},
                        {label:"Destiny",num:numerology.destiny,sub:"Outer Expression"}
                      ].map(({label,num,sub})=>(
                        <div key={label} className="section" style={{textAlign:"center",padding:28}}>
                          <div style={{fontFamily:"'Cormorant SC',serif",fontSize:9,color:"#c8a840",letterSpacing:3,marginBottom:12}}>{label}</div>
                          <div style={{fontFamily:"'Cormorant SC',serif",fontSize:56,color:"#e8c066",lineHeight:1,textShadow:"0 0 40px rgba(232,192,102,0.5)",marginBottom:8}}>{num}</div>
                          <div style={{fontSize:13,color:"#5a4a34",fontStyle:"italic"}}>{sub}</div>
                        </div>
                      ))}
                    </div>
                    <div className="section">
                      <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:20}}>PLANETARY POSITIONS</div>
                      <div className="planet-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                        {planetList.map((p,i)=>(
                          <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",borderBottom:"1px solid rgba(200,169,110,0.06)"}}>
                            <span style={{fontSize:16,color:ELEM_COL[p.sign_name||p.sign]||"#e8c066",width:20}}>{PLANET_SYM[p.name]||"★"}</span>
                            <span style={{fontSize:12,color:"#a08830",fontFamily:"'Cormorant SC',serif",letterSpacing:1,width:72}}>{p.name}</span>
                            <span style={{fontSize:13,color:"#b8a060",flex:1}}>{p.sign_name||p.sign||""}</span>
                            {p.house&&<span style={{fontSize:11,color:"#a08830"}}>H{p.house}</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Daily (in result view) */}
                {mainView==="daily" && (
                  <div className="fade section" style={{maxWidth:520,margin:"0 auto"}}>
                    <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:20}}>☽  DAILY ORACLE</div>
                    <div className="sign-grid" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:20}}>
                      {ZODIAC_SIGNS.map((s,i)=>(
                        <button key={s} className={`sign-btn ${dailySign===s?"sel":""}`} onClick={()=>setDailySign(s)}>
                          <div style={{fontSize:24,lineHeight:1,marginBottom:4}}>{SIGN_GLYPHS[i]}</div>
                          <div style={{fontSize:10,fontFamily:"'Cormorant SC',serif",letterSpacing:0,color:"#c8a840",lineHeight:1.3}}>{s}</div>
                        </button>
                      ))}
                    </div>
                    <button className="btn" onClick={fetchDailyReading} disabled={!dailySign||dailyLoading}>{dailyLoading?"Reading...":"Receive Today's Message"}</button>
                    {dailyReading&&(
                      <div style={{marginTop:24,paddingTop:24,borderTop:"1px solid rgba(232,192,102,0.25)"}}>
                        <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:12}}>{dailySign.toUpperCase()} · {new Date().toLocaleDateString("en-US",{month:"long",day:"numeric"})}</div>
                        <p style={{lineHeight:2,color:"#b8a060",fontSize:16,fontStyle:"italic"}}>{dailyReading}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {/* ════════════════════════════════════════════════════════════════ */}
        {/* ── COMPATIBILITY ── */}
        {/* ════════════════════════════════════════════════════════════════ */}
        {appTab==="compatibility" && (
          <>
            {compatStage==="form" && (
              <div className="fade">
                <div style={{textAlign:"center",marginBottom:36}}>
                  <h2 style={{fontFamily:"'Cormorant SC',serif",fontSize:18,fontWeight:300,letterSpacing:4,color:"#e8c066"}}>Compatibility Reading</h2>
                  <p style={{color:"#c8a840",fontSize:14,marginTop:8,letterSpacing:1}}>Synastry · Soul Contract · Lifetime Arc</p>
                </div>
                <div className="compat-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
                  <div className="section">
                    <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:24}}>FIRST PERSON</div>
                    <BirthForm data={person1} onChange={setPerson1}/>
                  </div>
                  <div className="section">
                    <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:24}}>SECOND PERSON</div>
                    <BirthForm data={person2} onChange={setPerson2}/>
                  </div>
                </div>
                {errorMsg&&<p style={{color:"#c87870",fontSize:13,margin:"16px 0",letterSpacing:1,textAlign:"center"}}>{errorMsg}</p>}
                <div style={{maxWidth:320,margin:"24px auto 0"}}>
                  <button className="btn" onClick={fetchCompatibility} disabled={compatLoading}>
                    {compatLoading?"Reading the stars...":"Read Our Compatibility"}
                  </button>
                </div>
              </div>
            )}

            {compatStage==="result" && compatScore && (
              <div className="fade">
                {/* Score display */}
                <div style={{textAlign:"center",marginBottom:36}}>
                  <p style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:4,marginBottom:16}}>COMPATIBILITY BETWEEN</p>
                  <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:"clamp(20px,4vw,32px)",fontWeight:300,color:"#e8c066",letterSpacing:3}}>
                    {person1.name} <span style={{color:"#806820",fontSize:"0.6em"}}>✦</span> {person2.name}
                  </h2>
                </div>

                {/* Score ring + verdict */}
                <div className="section" style={{maxWidth:480,margin:"0 auto 24px",textAlign:"center",padding:36}}>
                  <div style={{position:"relative",width:160,height:160,margin:"0 auto 24px"}}>
                    <svg viewBox="0 0 160 160" style={{position:"absolute",inset:0,transform:"rotate(-90deg)"}}>
                      <circle cx="80" cy="80" r="68" fill="none" stroke="rgba(232,192,102,0.25)" strokeWidth="4"/>
                      <circle cx="80" cy="80" r="68" fill="none" stroke="#e8c066" strokeWidth="4"
                        strokeDasharray={`${2*Math.PI*68*compatScore.score/100} ${2*Math.PI*68}`}
                        strokeLinecap="round"
                        style={{filter:"drop-shadow(0 0 8px rgba(232,192,102,0.6))"}}/>
                    </svg>
                    <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                      <div style={{fontFamily:"'Cormorant SC',serif",fontSize:42,color:"#e8c066",lineHeight:1}}>{compatScore.score}</div>
                      <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:2,marginTop:4}}>OUT OF 100</div>
                    </div>
                  </div>
                  <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:"#c8b87a",fontStyle:"italic",marginBottom:24,lineHeight:1.6}}>{compatScore.verdict}</p>
                  <div className="score-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,textAlign:"left",marginBottom:24}}>
                    <div>
                      <div style={{fontFamily:"'Cormorant SC',serif",fontSize:9,color:"#3a5a3a",letterSpacing:2,marginBottom:8}}>✦  STRENGTHS</div>
                      <p style={{fontSize:13,color:"#a08840",lineHeight:1.8,fontStyle:"italic"}}>{compatScore.strengths}</p>
                    </div>
                    <div>
                      <div style={{fontFamily:"'Cormorant SC',serif",fontSize:9,color:"#5a3a3a",letterSpacing:2,marginBottom:8}}>♄  CHALLENGES</div>
                      <p style={{fontSize:13,color:"#a08840",lineHeight:1.8,fontStyle:"italic"}}>{compatScore.challenges}</p>
                    </div>
                  </div>
                  <button className="btn" onClick={()=>setCompatExpanded(e=>!e)} style={{fontSize:11}}>
                    {compatExpanded?"Hide Full Reading":"Read Full Compatibility Reading"}
                  </button>
                </div>

                {/* Full reading */}
                {compatExpanded && (
                  <div className="fade section" style={{marginBottom:24,padding:32}}>
                    <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:24}}>DEEP COMPATIBILITY READING</div>
                    {compatScore.deepReading.split("\n\n").filter(Boolean).map((para,i)=>(
                      <p key={i} style={{lineHeight:2,color:"#c8b87a",fontSize:16,marginBottom:18,fontStyle:"italic",fontWeight:300}}>{para.replace(/\*\*/g,"")}</p>
                    ))}
                    {compatScore.timeline && (
                      <>
                        <div style={{display:"flex",alignItems:"center",gap:16,margin:"28px 0 20px"}}>
                          <div style={{flex:1,height:1,background:"rgba(232,192,102,0.25)"}}/>
                          <span style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3}}>RELATIONSHIP TIMELINE</span>
                          <div style={{flex:1,height:1,background:"rgba(232,192,102,0.25)"}}/>
                        </div>
                        <div style={{paddingLeft:16}}>
                          {compatScore.timeline.split("\n").filter(l=>l.trim()).map((line,i)=>{
                            const clean=line.replace(/^\*+\s*/,"").replace(/\*\*/g,"").trim();
                            if(!clean) return null;
                            const ci=clean.indexOf(":");
                            const hasDate=ci>0&&ci<40;
                            return (
                              <div key={i} className="tline">
                                {hasDate?(<>
                                  <div style={{fontFamily:"'Cormorant SC',serif",fontSize:11,color:"#e8c066",letterSpacing:2,marginBottom:4}}>{clean.slice(0,ci).toUpperCase()}</div>
                                  <div style={{fontSize:14,color:"#a08840",lineHeight:1.8,fontStyle:"italic"}}>{clean.slice(ci+1).trim()}</div>
                                </>):(
                                  <div style={{fontSize:14,color:"#a08840",lineHeight:1.8,fontStyle:"italic"}}>{clean}</div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                )}

                <div style={{maxWidth:320,margin:"0 auto"}}>
                  <button className="btn" onClick={()=>{setCompatStage("form");setCompatScore(null);setCompatExpanded(false);}}>
                    New Compatibility Reading
                  </button>
                </div>
              </div>
            )}
          </>
        )}

        {/* ════════════════════════════════════════════════════════════════ */}
        {/* ── DAILY ORACLE ── */}
        {/* ════════════════════════════════════════════════════════════════ */}
        {appTab==="daily" && (
          <div className="fade section" style={{maxWidth:520,margin:"0 auto"}}>
            <div style={{textAlign:"center",marginBottom:28}}>
              <h2 style={{fontFamily:"'Cormorant SC',serif",fontSize:16,fontWeight:300,letterSpacing:4,color:"#e8c066"}}>Daily Oracle</h2>
              <p style={{color:"#c8a840",fontSize:13,marginTop:8,letterSpacing:1}}>{new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}</p>
            </div>
            <div className="sign-grid" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:24}}>
              {ZODIAC_SIGNS.map((s,i)=>(
                <button key={s} className={`sign-btn ${dailySign===s?"sel":""}`} onClick={()=>setDailySign(s)}>
                  <div style={{fontSize:24,lineHeight:1,marginBottom:4}}>{SIGN_GLYPHS[i]}</div>
                          <div style={{fontSize:10,fontFamily:"'Cormorant SC',serif",letterSpacing:0,color:"#c8a840",lineHeight:1.3}}>{s}</div>
                        </button>
              ))}
            </div>
            <button className="btn" onClick={fetchDailyReading} disabled={!dailySign||dailyLoading}>
              {dailyLoading?"Reading...":"Receive Today's Message"}
            </button>
            {dailyReading && (
              <div style={{marginTop:28,paddingTop:28,borderTop:"1px solid rgba(232,192,102,0.25)"}}>
                <div style={{fontFamily:"'Cormorant SC',serif",fontSize:10,color:"#c8a840",letterSpacing:3,marginBottom:14}}>{dailySign.toUpperCase()} · {new Date().toLocaleDateString("en-US",{month:"long",day:"numeric"})}</div>
                <p style={{lineHeight:2.1,color:"#b8a060",fontSize:17,fontStyle:"italic"}}>{dailyReading}</p>
              </div>
            )}
          </div>
        )}

        {/* Footer */}
        <div style={{textAlign:"center",marginTop:72,color:"#14100a",fontSize:10,letterSpacing:6,fontFamily:"'Cormorant SC',serif"}}>
          ORACLEASTRO.COM
        </div>
      </div>
    </div>
  );
}
